export const ASSETS_CONSTANTS = {
  ICONS: {
    LOGO: 'assets/icons/logo.png',
  },
  IMAGES: {
    CREATOR_IMAGE: 'assets/images/creator_image.jpg',
    PLACE_HOLDER: 'assets/images/place-holder.png',
    BOOK_PLACE_HOLDER_IMAGE: 'assets/images/book_place_holder_image.jpg',
    ARTICLE_PLACE_HOLDER_IMAGE: 'assets/images/article_place_holder_image.png',
    VIDEO_PLACE_HOLDER_IMAGE: 'assets/images/video_place_holder_image.png',
    PODCAST_PLACE_HOLDER_IMAGE: 'assets/images/podcast_place_holder_image.png',
    WEBSITE_PLACE_HOLDER_IMAGE: 'assets/images/website_place_holder_image.png',
    RESEARCH_PAPER_PLACE_HOLDER_IMAGE: 'assets/images/research_paper_place_holder_image.png',
    OTHER_PLACE_HOLDER_IMAGE: 'assets/images/other_place_holder_image.png',
    KINDLE_LOGO: 'assets/images/kindle_logo.png',
    APPLE_BOOK_LOGO: 'assets/images/apple_book_logo.png',
    KINDLE_HTML_IMPORT_GUIDE: {
      STEP_1: 'assets/images/kindle_html_import_guide/kindle_html_import_guide_step_1.jpeg',
      STEP_2: 'assets/images/kindle_html_import_guide/kindle_html_import_guide_step_2.jpeg',
      STEP_3: 'assets/images/kindle_html_import_guide/kindle_html_import_guide_step_3.jpeg',
      STEP_4: 'assets/images/kindle_html_import_guide/kindle_html_import_guide_step_4.jpeg',
      STEP_5: 'assets/images/kindle_html_import_guide/kindle_html_import_guide_step_5.jpeg',
      STEP_6: 'assets/images/kindle_html_import_guide/kindle_html_import_guide_step_6.jpeg',
    }
  },
  TEMPLATES: {
    EXCEL_IMPORT_TEMPLATE: 'assets/templates/kindle-html-import-template.xlsx',
  },
  FONTS: {
    EBGaramond: 'EBGaramond-VariableFont_wght.ttf',
    EBGaramond_ITALIC: 'EBGaramond-Italic-VariableFont_wght.ttf',
  }
} as const;
